var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIconShareToCommunity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-icon-share-to-community",
    transform: "translate(-0.343 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(2.229 4.457)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 2.547,
    cy: 2.547,
    rx: 2.547,
    ry: 2.547,
    transform: "translate(0 7.338)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 2.547,
    cy: 2.547,
    rx: 2.547,
    ry: 2.547,
    transform: "translate(13.321 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 2.547,
    cy: 2.547,
    rx: 2.547,
    ry: 2.547,
    transform: "translate(13.321 14.675)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10",
    "data-name": "Line 10",
    x2: 8.859,
    y2: 4.88,
    transform: "translate(4.778 11.113)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11",
    "data-name": "Line 11",
    x1: 8.859,
    y2: 4.88,
    transform: "translate(4.778 3.775)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5655",
    "data-name": "Rectangle 5655",
    width: 24,
    height: 28,
    transform: "translate(0.343 0)",
    fill: "none",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIconShareToCommunity);
export default __webpack_public_path__ + "static/media/card-icon-share-to-community.d966c19c64492e38a5dca512e9364daa.svg";
export { ForwardRef as ReactComponent };